import { render } from "./TypeOfVouchers.vue?vue&type=template&id=c6dac900"
import script from "./TypeOfVouchers.vue?vue&type=script&lang=js"
export * from "./TypeOfVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__